<template>
<v-card flat>
    <v-card-text class="title mt-10">
        Change Password
    </v-card-text>
    <v-divider></v-divider>
    <div class="pa-5">
        <v-alert v-model="alert" text prominent type="error" icon="mdi-cloud-alert">
            {{text}}
        </v-alert>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
                <v-col cols="12" class="py-0">
                    <v-text-field class="border-radius" v-model="changePasswords.current_password" :rules="[v => !!v || 'Current Password is required']" :append-icon="passwardShow1 ? 'mdi-eye' : 'mdi-eye-off'" :type="passwardShow1 ? 'text' : 'password'" @click:append="passwardShow1 = !passwardShow1" outlined label="Current Password" required dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field class="border-radius" outlined v-model="confirmPassword" :rules="[v => !!v || 'New Password is required']" :append-icon="passwardShow ? 'mdi-eye' : 'mdi-eye-off'" :type="passwardShow ? 'text' : 'password'" @click:append="passwardShow = !passwardShow" label="New Password" required dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field class="border-radius" v-model="changePasswords.new_password" outlined :rules="[v => !!v || 'Re Enter is required']" :append-icon="passwardShow ? 'mdi-eye' : 'mdi-eye-off'" :type="passwardShow ? 'text' : 'password'" @click:append="passwardShow = !passwardShow" label="Re Enter" required dense></v-text-field>
                </v-col>
            </v-row>
        </v-form>
        <v-card-actions class="px-0">
            <v-btn color="blue darken-1" :loading="IsTrue" class="px-4" dark @click="Change">Change Password</v-btn>
        </v-card-actions>
    </div>
</v-card>
</template>

<script>
import {
    mapMutations,
    mapActions
} from 'vuex'
export default {
    data: () => ({
        alert: false,
        text: '',
        IsTrue: false,
        passwardShow: false,
        passwardShow1: false,
        changePasswords: {
            current_password: "",
            new_password: ""
        },
        confirmPassword: '',
        valid: false
    }),
    methods: {
        ...mapMutations(['SnackbarSuccess']),
        ...mapActions(['PostResponse']),
        async Change() {
            if (this.$refs.form.validate()) {
                this.alert = false
                if (this.changePasswords.new_password === this.confirmPassword) {
                    this.IsTrue = true
                    try {
                        let value = {
                            url: '/internal/v2/user/password',
                            data: this.changePasswords
                        }
                        const data = (await this.PostResponse(value)).data
                        if (data.success) {
                            this.$refs.form.resetValidation()
                            this.passwardShow = false
                            this.passwardShow1 = false
                            this.changePasswords.current_password = ''
                            this.changePasswords.new_password = ''
                            this.confirmPassword = ''
                            this.SnackbarSuccess(data)
                            this.IsTrue = false
                        }
                    } catch (error) {
                        let data = {
                            success : !error.response.data.success,
                            message : error.response.data.errors[0].message,
                            action : 'error'
                        }
                        this.SnackbarSuccess(data)
                        this.IsTrue = false
                    }
                } else {
                    this.alert = true
                    this.text = "Password no match"
                }
            }
        }
    }
}
</script>
